import * as React from "react";
import BaseWSTmp from "./base-ws-tmp";

// 客服发送的群组消息

// 消息枚举
import { ENoticeLevel, EReadStatus, ECollectStatus } from "utils/enum/notice";

// 订单更新时推送的消息

interface IGroupWSTmpProps {
  // 未读 Yes:已读  No:未读
  isRead?: EReadStatus;
  // 未收藏 Yes:已收藏 No:未收藏
  isCollect?: ECollectStatus;
  // 消息级别
  isNoticeLevel?: ENoticeLevel;
}
class GroupWSTmp extends React.Component<IGroupWSTmpProps, any> {
  constructor(props: IGroupWSTmpProps) {
    super(props);
  }

  render() {
    const preInfo = `通知：单品奖励来啦~~~~\n下单日期7月24日--7月31日，出行日期不限。\n帆船：银魂，太阳风（8.2首航），女王，\n蓝高。\n游艇：云影，女神，波斯`;
    const content = (
      <div className="group-notice">
        <a href="javascript:void(0)">泰国天猫组</a>
        <pre>{preInfo}</pre>
      </div>
    );
    return <BaseWSTmp {...this.props} slot={content} />;
  }
}

export default GroupWSTmp;
